import React, { useEffect } from 'react';
import { SheetCanvas } from './SheetCanvas';
import { packGroups } from './MyPack';
import { connect } from 'react-redux'
import { getGroupsOnSheet, getSheetById } from '../../redux/store'
import { getPaperSize, getPrintableArea } from './paperSizes';
import { maxHeightRatio, effectiveRenderStyle } from '../../utils/util';


// Turn a MiniGroup into a packable item: its per-mini cell size (cellWidth ×
// cellHeight) and count. The packer (packGroups) decides how the group wraps into
// a grid based on the free space it actually lands in, so columns/rows/width/
// height are filled in during packing, not here (MINI-26).
export function toSize(group) {
    const size = group.size || group.creature.size;
    // Size the whole group to the tallest variant so mixed-height art shares a
    // fold/base line (MINI-23).
    const ratio = maxHeightRatio(group.creature);

    // Flat tokens have no fold and no base, so the cell is just the token's
    // bounding box: longest side = size (MINI-24).
    const renderStyle = effectiveRenderStyle(group);
    if (renderStyle === 'roundToken') {
        return { ...group, count: group.count, cellWidth: size, cellHeight: size };
    }
    if (renderStyle === 'rectToken') {
        return {
            ...group,
            count: group.count,
            cellWidth: ratio <= 1 ? size : size / ratio,
            cellHeight: ratio <= 1 ? size * ratio : size,
        };
    }

    return {
        ...group,
        count: group.count,
        cellWidth: group.vertical ? size : size * 2,
        cellHeight: size * (ratio + 0.5) * (group.vertical ? 2 : 1), // base is half of the size
    };
}


export const PackedSheetView = React.forwardRef((props, ref) => {
    // console.log("packed props", props)
    const {groups, onCanvasDrop, showGui, sheet, paper, onFitChange } = props;
    const area = getPaperSize(paper, sheet);
    // Pack into the same margin-reduced rectangle the canvas renders, so nothing
    // lands in the bottom/right strip the canvas would clip (MINI-28).
    const printable = getPrintableArea(area);

    // TODO: all users are treated as non-premium for now. Once accounts have a
    // premium flag, only restrict packing width for non-premium users.
    const packableWidth = printable.width * (2 / 3);
    let sized = groups.map(group => toSize(group));
    // Groups that don't fit aren't dropped or stacked on top of each other — the
    // packer flows them into a spill band below the page (each keeps a valid,
    // non-overlapping rect). The band itself is the "doesn't fit" signal, so no
    // whole-sheet red border is needed (MINI-29).
    const { didFit } = packGroups(sized, [{ x: 0, y: 0, width: packableWidth, height: printable.height }]);

    useEffect(() => {
        if (onFitChange) onFitChange(didFit);
    }, [didFit, onFitChange]);

    return <div id="printable-view" style={{ border: "1px solid grey" }}>
        <SheetCanvas groups={sized} onDrop={onCanvasDrop} showGui={showGui} paper={area} ref={ref} />
    </div>;
});

function mapStateToProps(state, ownProps) {
    var sheet = ownProps.sheet;
    var groups = ownProps.groups;
    // console.log("props", state, ownProps)
    if (!sheet && ownProps.sheetId) {
        sheet = getSheetById(state, ownProps.sheetId)
    }
    if (sheet) {
        if (!groups) groups = getGroupsOnSheet(state, sheet.id);
        if (!sheet.papersize) {
            sheet = { ...sheet, papersize: getPaperSize(null, null) };
        }
    }
    // creatures = getCreatures(state);
    // console.log("groups on sheet", groups)
    return { sheet, groups };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(PackedSheetView)